// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1yLzA","label":"LabeledBox_label__2JlYK"};